import styled from 'styled-components';
import StopStates from './StopStates';
import { colorSchema } from 'utils/style';

export default styled(StopStates)`
  .stop-states {
    display: flex;
    flex-direction: column;

    &__item {
      display: flex;
      &:last-of-type {
        .stop-states__icon-container {
          &:after {
            display: none;
          }
        }
      }
    }

    &__body {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
    }

    &__icon-container {
      align-items: center;
      display: flex;
      flex-direction: column;
      margin-right: 0.8rem;

      &:after {
        content: '';
        background: ${colorSchema('grey300')};
        height: 34px;
        margin: 0.3rem 0;
        width: 2px;
      }

      &--completed {
        &:after {
          background: ${colorSchema('primary300')};
        }
      }

      &--withAction {
        &:after {
          height: 42px;
        }
      }

      &--is-late {
        &:after {
          background: ${colorSchema('accent300')};
          height: 56px;
        }
        .stop-states__icon {
          background: ${colorSchema('accent300')};
          &:before {
            border: 2px solid ${colorSchema('accent300')};
          }
        }
      }
    }

    &__icon {
      align-items: center;
      border-radius: 50%;
      background: ${colorSchema('grey300')};
      border: 3px solid ${colorSchema('white')};
      display: flex;
      height: 18px;
      justify-content: center;
      position: relative;
      width: 18px;

      &:before {
        border: 2px solid ${colorSchema('grey300')};
        border-radius: 50%;
        content: '';
        display: block;
        position: absolute;
        height: 20px;
        width: 20px;
      }

      svg {
        height: 8px;
        fill: ${colorSchema('white')};
        width: 8px;
      }

      &--completed {
        background: ${colorSchema('primary300')};

        &:before {
          border: 2px solid ${colorSchema('primary300')};
        }
      }
    }

    &__action {
      margin: 0.8rem 0;
    }

    &__pending-label {
      color: ${colorSchema('grey700')};
    }

    &__reject-label {
      color: ${colorSchema('error500')};
    }

    &__late-label {
      color: ${colorSchema('accent900')};
    }
  }
`;
